import React from 'react';

import 'react-loading-skeleton/dist/skeleton.css';

const DashboardWidgetPlaceholderFile = () => (
  <div className="widget widget-grid-skeleton grid-item invisible">
    <div className="grid-item-img-wrapper" />
    <div className="grid-item-body" />
  </div>
);

export default DashboardWidgetPlaceholderFile;
